module.exports = __webpack_public_path__ + "img/testCaseFail.0bf5ea82.svg";